import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { gql } from '@/clients/utoniq-core'
import {
  ConsoleMembershipExplainQuery,
  ConsoleMembershipExplainQueryVariables,
} from '@/clients/utoniq-core/schema'
import { getAppNameByPlatformAndSubscription } from '@/components/pages/ArtistMembership/viewModel'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()

  const { data, loading } = useQuery<
    ConsoleMembershipExplainQuery,
    ConsoleMembershipExplainQueryVariables
  >(QUERY)

  const app = useMemo<string | undefined>(
    () => getAppNameByPlatformAndSubscription(data?.artist?.subscription),
    [data?.artist?.subscription]
  )

  return {
    state: {
      artistId: user?.uid ?? '',
      app,
      loading,
    },
    actions: {},
  }
})

const QUERY = gql`
  query ConsoleMembershipExplain {
    artist {
      id
      subscription {
        amount
        content
        status
        productId
        playstore {
          productId
        }
        appstore {
          productId
        }
      }
    }
  }
`
